import { Injectable, Inject } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { JWT_STORAGE_KEY_CONFIGURATION_TOKEN } from '../tokens';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  key;

  constructor(
    @Inject(JWT_STORAGE_KEY_CONFIGURATION_TOKEN) configuration: string
  ) {
    this.key = configuration;
  }

  getToken(): string {
    return sessionStorage.getItem(this.key);
  }

  setToken(token: string): void {
    sessionStorage.setItem(this.key, token);
  }

  destroyToken(): void {
    sessionStorage.removeItem(this.key);
    sessionStorage.clear();
  }

  hasValidAccessToken(): boolean {
    return !new JwtHelperService().isTokenExpired(this.getToken());
  }

  getTokenExpirationDate(): Date {
    return new JwtHelperService().getTokenExpirationDate(this.getToken());
  }
}
